export default __webpack_public_path__ + "static/media/bulb_rocket.8c2577d8.png";